// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__D1jVM","bounce":"styles_bounce__QFdXi"};